import { ApplicationUserViewModel, TrackableObjectBase } from '../../models';
import { wideService } from '../../common/constants';

export function getDefaultUser(item: TrackableObjectBase, isCreator: boolean, defaultUserName: string): ApplicationUserViewModel {
    if (item.creationUser === wideService) {
        return {
            displayName: wideService,
            initials: 'WS'
        } as ApplicationUserViewModel;
    } else {
        const creationUser = item.creationUser ?? defaultUserName;
        if (isCreator) {
            return {
                displayName: creationUser,
                initials: ''
            } as ApplicationUserViewModel;
        } else {
            return {
                displayName: item.lastModifier ?? creationUser,
                initials: ''
            } as ApplicationUserViewModel;
        }
    }
}